<template>
  <div class="select-element">
    <label>{{ title }}</label>
    <div>
      <el-select
        clearable
        :value="value"
        class="select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.rolesOffice"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectRoleOffice',
  props: ['value', 'title'],
  data() {
    return {
      selects: {
        simple: '',
        rolesOffice: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  created() {
    this.fetchData();
    this.selects.simple = this.value;
  },
  methods: {
    fetchData() {
      return this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/roleofficeEntities`)
        .then(response => {
          this.selects.rolesOffice = response.data._embedded.roleofficeEntities.map(
            entity => ({
              value: entity.roleofId,
              label: entity.roleofName,
            }),
          );
        });
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
.select-element {
  padding-left: 30px;
}
</style>
